import {
	Badge,
	Button,
	em,
	Flex,
	Group,
	ScrollArea,
	Table,
	Text,
} from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import Colors from '../../../constants/colors'
import { useNavigate } from 'react-router-dom'

export const Addresses = [
	{
		id: '1',
		name: 'Ali Khan',
		street: 'House 12, Street 5, F-10',
		city: 'Islamabad',
		state: 'Islamabad Capital Territory',
		zip: '44000',
		country: 'Pakistan',
		isDefault: true,
	},
	{
		id: '2',
		name: 'Sana Ahmed',
		street: 'Flat 4B, Gulshan-e-Iqbal Block 13',
		city: 'Karachi',
		state: 'Sindh',
		zip: '75300',
		country: 'Pakistan',
	},
	{
		id: '3',
		name: 'Usman Raza',
		street: 'Street 22, Cavalry Ground',
		city: 'Lahore',
		state: 'Punjab',
		zip: '54000',
		country: 'Pakistan',
	},
	{
		id: '4',
		name: 'Ayesha Noor',
		street: 'Plot 78, Phase 6, DHA',
		city: 'Karachi',
		state: 'Sindh',
		zip: '75500',
		country: 'Pakistan',
	},
	{
		id: '5',
		name: 'Bilal Hassan',
		street: 'House 92, Satellite Town',
		city: 'Rawalpindi',
		state: 'Punjab',
		zip: '46000',
		country: 'Pakistan',
	},
	{
		id: '6',
		name: 'Nida Tariq',
		street: 'House 25, University Town',
		city: 'Peshawar',
		state: 'Khyber Pakhtunkhwa',
		zip: '25000',
		country: 'Pakistan',
	},
	{
		id: '7',
		name: 'Zain Ali',
		street: 'Main Road, G-11 Markaz',
		city: 'Islamabad',
		state: 'Islamabad Capital Territory',
		zip: '44000',
		country: 'Pakistan',
	},
]

const AddressBook = () => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	const navigate = useNavigate()

	const rows = Addresses.map((address) => (
		<Table.Tr key={address.id}>
			<Table.Td>
				<Group gap='xs'>
					<Text fw={500}>{address.name}</Text>
					{address.isDefault && <Badge color='green'>Default</Badge>}
				</Group>
			</Table.Td>
			<Table.Td>
				{address.street}, {address.city}, {address.state} {address.zip}
			</Table.Td>
			<Table.Td>{address.country}</Table.Td>
			<Table.Td>
				<Group gap='xs'>
					<Button
						variant='light'
						size='xs'
						// onClick={() => onEdit?.(address.id)}
					>
						Edit
					</Button>
					<Button
						color='red'
						variant='light'
						size='xs'
						// onClick={() => onDelete?.(address.id)}
					>
						Delete
					</Button>
				</Group>
			</Table.Td>
		</Table.Tr>
	))

	return (
		<>
			<Flex
				gap='xs'
				justify='space-between'
				align='center'
				mb='md'
				direction={'column'}
				w={isMobile ? '100%' : '80%'}
				mx='auto'
			>
				<Flex
					w={'100%'}
					gap='xs'
					my={30}
					justify='space-between'
					align='center'
				>
					<Text fz='lg' fw={500}>
						Address Book
					</Text>
					<Button
						variant='outline'
						color={Colors.primaryColor}
						size='md'
						radius={'lg'}

						onClick={() => {
							navigate('/add-new-address')
						}}
					>
						Add New Address
					</Button>
				</Flex>
				<ScrollArea w={'100%'}>
					<Table striped highlightOnHover withTableBorder withColumnBorders>
						<Table.Thead >
							<Table.Tr>
								<Table.Th>Name</Table.Th>
								<Table.Th>Address</Table.Th>
								<Table.Th>Country</Table.Th>
								<Table.Th>Actions</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>{rows}</Table.Tbody>
					</Table>
				</ScrollArea>
			</Flex>
		</>
	)
}

export default AddressBook
